require('./groupon.coffee');

Groupon.Validate = {
  email: function(value) {
    var re;
    value = $.trim(value);
    if (value.length > 100) {
      return false;
    }
    re = /^(^[a-zA-Z0-9\!\#\$\%\&'\*\+\-\/\=\?\^\_\`\{\|\}\~]+[.]?[a-zA-Z0-9\!\#\$\%\&'\*\+\-\/\=\?\^\_\`\{\|\}\~]+|[a-zA-Z0-9\!\#\$\%\&'\*\+\-\/\=\?\^\_\`\{\|\}\~]{1})@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
    return re.test(value);
  },
  zip: function(value) {
    var regexp, zip;
    if (value === '' || value === 'undefined') {
      return false;
    }
    zip = $.trim(value);
    regexp = /(^([0-9]{5}(-[0-9]{4})?)$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)/;
    return regexp.test(zip);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvc3JhamVuZHJhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MTU0OTM1MTMxODktODY0MS9wcm9kdWN0aW9uLTIwMTguMDEuMDlfMDkuNTEvc3Vic2NyaXB0aW9uX2Zsb3cvbW9kdWxlcy9ncm91cG9uL2Zyb250ZW5kL3ZhbGlkYXRlLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3NyYWplbmRyYW4vbmFwaXN0cmFuby9idWlsZC8xNTE1NDkzNTEzMTg5LTg2NDEvcHJvZHVjdGlvbi0yMDE4LjAxLjA5XzA5LjUxL3N1YnNjcmlwdGlvbl9mbG93L21vZHVsZXMvZ3JvdXBvbi9mcm9udGVuZC92YWxpZGF0ZS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBV0EsT0FBQSxDQUFRLGtCQUFSOztBQUVBLE9BQU8sQ0FBQyxRQUFSLEdBR0U7RUFBQSxLQUFBLEVBQU8sU0FBQyxLQUFEO0FBQ0wsUUFBQTtJQUFBLEtBQUEsR0FBUSxDQUFDLENBQUMsSUFBRixDQUFPLEtBQVA7SUFDUixJQUFnQixLQUFLLENBQUMsTUFBTixHQUFlLEdBQS9CO0FBQUEsYUFBTyxNQUFQOztJQUNBLEVBQUEsR0FBSztBQUNMLFdBQU8sRUFBRSxDQUFDLElBQUgsQ0FBUSxLQUFSO0VBSkYsQ0FBUDtFQU1BLEdBQUEsRUFBSyxTQUFDLEtBQUQ7QUFDSCxRQUFBO0lBQUEsSUFBZ0IsS0FBQSxLQUFTLEVBQVQsSUFBZSxLQUFBLEtBQVMsV0FBeEM7QUFBQSxhQUFPLE1BQVA7O0lBQ0EsR0FBQSxHQUFNLENBQUMsQ0FBQyxJQUFGLENBQU8sS0FBUDtJQUNOLE1BQUEsR0FBVTtXQUNWLE1BQU0sQ0FBQyxJQUFQLENBQVksR0FBWjtFQUpHLENBTkwifQ==
